// extracted by css-extract-rspack-plugin
export default {"root":"vzYGNU","total":"Y9QPEs","heading":"wI2699"};